import country from "./country";
import { images, svg } from "./images";
import THEME, { COLORS, SIZES, FONTS, DateFormat } from "./theme";
import { DefaultFormLayout, FullSpan } from "./formWrapper";
import { recentReportscolumns } from "./tableColumns";
import OPTIONS, { userTypeValues, userLevelValues } from "./selectOptions";
import { details } from "./userDetails";
import { contactsProperty } from "./contacts";
const { ReportsSVG, ManageTRESVG, ManageUserAccount } = svg;

export {
  contactsProperty,
  details,
  recentReportscolumns,
  DefaultFormLayout,
  FullSpan,
  ReportsSVG,
  ManageTRESVG,
  ManageUserAccount,
  country,
  images,
  THEME,
  COLORS,
  SIZES,
  FONTS,
  DateFormat,
  OPTIONS,
  userTypeValues,
  userLevelValues,
};
